import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { WorkflowSettings } from '@/components/settings/WorkflowSettings'
import { CarrierManagement } from '@/components/settings/CarrierManagement'
import { ConfidenceThresholdSettings } from '@/components/settings/ConfidenceThresholdSettings'
import { FeatureFlagsSettings } from '@/components/settings/FeatureFlagsSettings'

export function Settings() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Settings</h1>
        <p className="text-muted-foreground">
          Configure system settings and manage carriers
        </p>
      </div>

      <Tabs defaultValue="workflows" className="space-y-4">
        <TabsList>
          <TabsTrigger value="workflows">Workflows</TabsTrigger>
          <TabsTrigger value="carriers">Carriers</TabsTrigger>
        </TabsList>

        <TabsContent value="workflows" className="space-y-6">
          <WorkflowSettings />
          <ConfidenceThresholdSettings />
          <FeatureFlagsSettings />
        </TabsContent>

        <TabsContent value="carriers">
          <CarrierManagement />
        </TabsContent>
      </Tabs>
    </div>
  )
}
